
const list = {
  path: 'list/:pages',
  component: resolve => require(['../../../../../pages/modules/securityService/list'], resolve),
}

export default list
